import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';

import useText from '@hooks/use-text';

import './Footer.scss';

interface FooterProps {
    next: () => void;
    onCancel(): void;
}

export const V4Footer = ({ next, onCancel }: FooterProps) => {
    const { formCancel, transferContinue } = useText();

    return (
        <div className="footer-fixed">
            <div className="footer-button-row">
                <LinkButton onClick={onCancel}>{formCancel}</LinkButton>
                <StandardButton onClick={next} disabled={false}>
                    {transferContinue}
                </StandardButton>
            </div>
        </div>
    );
};
